import { AlertCircle } from 'lucide-react'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { RECORDING_LOAD_FAILED_MESSAGE } from '../useRecordingPlayback'

interface RecordingLoadErrorProps {
  message?: string
  onRetry?: () => void
  /** Dark-variant surfaces need their own text colour. */
  messageClassName?: string
}

/**
 * The single failure surface for recording playback, shared by both players and
 * the sheet. Replaced a per-player fallback that rendered a second `<audio>`
 * pointed at the URL that had just failed, so it never played either.
 */
export function RecordingLoadError({
  message = RECORDING_LOAD_FAILED_MESSAGE,
  onRetry,
  messageClassName,
}: RecordingLoadErrorProps) {
  return (
    <Alert variant="destructive" className="border-none bg-transparent py-1">
      <AlertCircle />
      <AlertDescription className="flex items-center gap-3">
        <span className={messageClassName}>{message}</span>
        {onRetry && (
          <Button type="button" variant="outline" size="xs" onClick={onRetry}>
            Retry
          </Button>
        )}
      </AlertDescription>
    </Alert>
  )
}
